import { render, staticRenderFns } from "./KSROnlineOffer.vue?vue&type=template&id=96dd3756&"
import script from "./KSROnlineOffer.vue?vue&type=script&lang=js&"
export * from "./KSROnlineOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports